import { FunctionalComponent, h } from 'preact';
import { lazy, Suspense } from 'preact/compat';
import { Skeleton } from 'components/skeleton/skeleton';
import { About } from 'components/about/about';
import { Login } from 'components/login/login';
import { ForgotPassword } from 'components/login/forgot-password/forgot-password';
import { Recovery } from 'components/login/recovery/recovery';
import { LstUpgrade } from 'components/live-site-translations/lst-upgrade';
import { AddonsAndSettings } from 'components/addons-and-settings/addons-and-settings';
import { ManageSkeleton } from 'components/manage/manage-skeleton/manage-skeleton';
import { ReportView } from 'components/report/report';
import { HowItWorksPage } from 'components/how-it-works/how-it-works-page';
import { InitialPageSections } from './initial-page-sections';
import { InitialPageLst } from './initial-page-lst';
import { Views } from './types';

const ManageInterfaceLazy = lazy(() =>
  import('../manage-interface/manage-interface').then((m) => ({ default: m.ManageInterface })),
) as unknown as FunctionalComponent<{ view: Views }>;

const createManageView = (view: Views) => () => (
  <Suspense key="manage" fallback={<ManageSkeleton withWCAGSummary />}>
    <ManageInterfaceLazy view={view} />
  </Suspense>
);

const VIEW_COMPONENTS: Partial<Record<Views, () => JSX.Element>> = {
  [Views.SkeletonPage]: () => <Skeleton />,
  [Views.InitialPage]: () => <InitialPageSections />,
  [Views.InitialPageLst]: () => <InitialPageLst />,
  [Views.ReportPage]: () => <ReportView />,
  [Views.AboutPage]: () => <About />,
  [Views.HowItWorksPage]: () => <HowItWorksPage />,
  [Views.Login]: () => <Login />,
  [Views.ForgotPassword]: () => <ForgotPassword />,
  [Views.Recovery]: () => <Recovery />,
  [Views.LstUpgrade]: () => <LstUpgrade />,
  [Views.AddonsAndSettings]: () => <AddonsAndSettings />,
  [Views.Manage]: createManageView(Views.Manage),
  [Views.Remediations]: createManageView(Views.Remediations),
};

interface InitialPageViewProps {
  view: Views;
}

export const InitialPageView: FunctionalComponent<InitialPageViewProps> = ({ view }) => {
  const Component = VIEW_COMPONENTS[view];
  return Component ? <Component /> : null;
};
